import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import AloeVera from "../../../assets/images/Eductional/AloeVera.png";
import Image1 from "../../../assets/images/Eductional/Image1.png";
import { useLocation } from "react-router-dom";
import {
  getDetailResource,
  getSpecialitiesList,
} from "../../../services/services";
import Spinner from "../../../components/Loader/Spinner";
import { FiDownload, FiEye } from "react-icons/fi";

const DeatailResourcesPage = () => {
  const { id } = useParams();

  const [resourceDetail, setResourceDetail] = useState(null);

  const [loading, setLoading] = useState(false);

  const { state } = useLocation();

  useEffect(() => {
    const fetchDetail = async () => {
      try {
        setLoading(true);
        const res = await getDetailResource(id);

        const data = res?.data || res;

        console.log("Fetched Detail Data:", res);
        setResourceDetail(data);
      } catch (err) {
        console.log("Detail fetch error", err);
      } finally {
        setLoading(false);
      }
    };

    if (id) fetchDetail();
  }, [id]);

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = resourceDetail.file.fileUrl;
    link.setAttribute("download", "");
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  const getFileExtension = (fileUrl) => {
    if (!fileUrl) return "";

    return fileUrl.split(".").pop()?.split("?")[0].toUpperCase();
  };

  return (
    <div className="mt-4 mx-24 px-4 py-6 ">
      {/* <div className="relative mb-48"> */}
      <div className="relative mb-56">
        <img
          src={resourceDetail?.cover_image?.imageUrl || AloeVera}
          alt=""
          className="w-full h-96 object-cover rounded-3xl"
        />
        {resourceDetail && (
          <>
            <div className="absolute top-2 left-3">
              <button
                onClick={() => window.history.back()}
                className="flex items-center gap-2 border-l border-r border-b border-primary border-t-0 px-4 py-2 rounded-full text-white shadow-sm"
                style={{
                  background:
                    "linear-gradient(to bottom, #9A72C9 0%, #9A72C9 30%, #F4C4EE 100%)",
                }}
              >
                ← Back
              </button>
            </div>
            <div
              // className="absolute left-8 text-3xl font-bold bg-white rounded-3xl p-10 shadow-lg"
              // style={{ top: "80%", width: "50%" }}
              className="absolute left-8 text-3xl font-bold bg-white rounded-3xl p-10 shadow-lg lg:w-1/2 md:w-2/3 w-2/3"
              style={{ top: "80%" }}
            >
              {resourceDetail?.categoriesData?.length > 0 && (
                <span
                  className="text-sm py-1 px-3 uppercase  text-blue rounded-3xl "
                  style={{ backgroundColor: "#DBEEFA" }}
                >
                  {state?.tag || " "}
                  {resourceDetail?.categoriesData
                    ?.map((c) => c.name)
                    .join(", ") || " "}
                </span>
              )}
              <h1 className="mt-6 text-xl italic font-light leading-10 max-w-md">
                {/* {state?.title ||
              "Aloe Vera Elixir: Nature's Blessing for Radiant Skin"} */}
                {resourceDetail?.title || ""}
              </h1>
              <div>
                <div className="flex items-center text-sm font-normal text-Textgray mt-4">
                  <span>
                    By {resourceDetail?.creator?.firstName}{" "}
                    {resourceDetail?.creator?.lastName}
                  </span>

                  {/* <span className="mx-2 text-skyblue">•</span> */}

                  {/* <span>{state?.read || "12 Min Read"}</span> */}

                  <span className="mx-2 text-skyblue">•</span>

                  <span>
                    Updated{" "}
                    {resourceDetail?.updatedAt
                      ? new Date(resourceDetail.updatedAt).toLocaleDateString(
                        "en-US",
                        {
                          month: "short",
                          year: "numeric",
                        },
                      )
                      : ""}
                  </span>
                </div>
                <div className="flex flex-wrap items-center gap-2 mt-2">
                  {resourceDetail?.tags?.map((tag, index) => (
                    <span
                      key={index}
                      className="text-sm py-1 px-3 uppercase text-primary rounded-3xl"
                      style={{ backgroundColor: "#F3E8FF" }}
                    >
                      #{tag}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </>
        )}
      </div>

      {resourceDetail?.specialitiesData?.length > 0 && (
        <div className="mt-4 text-lg font-semibold max-w-xl mx-auto text-left text-gray-700 flex items-center gap-2 flex-wrap">
          <span>Specialities:</span>

          <span>
            {resourceDetail.specialitiesData
              .map(
                (item) =>
                  item.specialityName.charAt(0).toUpperCase() +
                  item.specialityName.slice(1),
              )
              .join(", ")}
          </span>
        </div>
      )}

      <div className="my-6 max-w-xl mx-auto text-left items-center">
        {loading ? (
          <Spinner />
        ) : (
          <>
            <div
              className="py-4 text-gray-700 leading-relaxed"
              dangerouslySetInnerHTML={{ __html: resourceDetail?.description }}
            />

            <div
              className="py-4 text-gray-700 leading-relaxed"
              dangerouslySetInnerHTML={{ __html: resourceDetail?.textContent }}
            />

            {resourceDetail?.file?.fileUrl && (
              <div className="max-w-xl mx-auto mt-10">
                {/* {resourceDetail?.resourceType === "pdf" &&  */}
                {resourceDetail?.file?.fileUrl && getFileExtension(resourceDetail?.file?.fileUrl) !== "MP4" && (
                  <div className="flex items-center justify-between bg-white border border-gray-200 rounded-xl px-4 py-3 hover:shadow-md transition">
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 flex items-center justify-center bg-red-100 text-red-600 rounded-lg text-xs font-semibold">
                        {/* PDF */}
                        {getFileExtension(resourceDetail.file.fileUrl) === "PDF" ? "PDF" : getFileExtension(resourceDetail.file.fileUrl) === "JPG" ? "Image" : getFileExtension(resourceDetail.file.fileUrl) === "JPEG" ? "Image" : getFileExtension(resourceDetail.file.fileUrl) === "PNG" && "Image"}
                      </div>

                      <p className="text-sm text-gray-700 max-w-[200px] truncate">
                        {resourceDetail.file.fileUrl.split("/").pop()}
                      </p>
                    </div>

                    <div className="flex items-center gap-2">
                      <button
                        onClick={() =>
                          window.open(resourceDetail.file.fileUrl, "_blank")
                        }
                        className="p-2 rounded-full text-primary flex items-center hover:bg-Lightgray transition"
                      >
                        <FiEye size={20} />
                      </button>

                      <button
                        onClick={handleDownload}
                        className="p-2 rounded-full text-primary flex items-center hover:bg-Lightgray transition"
                      >
                        <FiDownload size={20} />
                      </button>
                    </div>
                  </div>
                )}

                {/* {resourceDetail?.resourceType === "video" ( */}
                {resourceDetail?.file?.fileUrl && getFileExtension(resourceDetail?.file?.fileUrl) === "MP4" && (
                  <div className="max-w-xl mx-auto mt-10">
                    <div className="rounded-xl overflow-hidden border border-gray-200 shadow-sm">
                      <video
                        controls
                        className="w-full h-[400px] object-cover bg-black"
                      >
                        <source
                          src={resourceDetail.file.fileUrl}
                          type="video/mp4"
                        />
                        Your browser does not support the video tag.
                      </video>
                    </div>
                  </div>
                )}
              </div>
            )}
          </>
        )}
      </div>

      {/* <div className="my-6  max-w-xl mx-auto text-left ">
        {resourceDetail.map((item, index) => {
          switch (item.type) {
            case "paragraph":
              return (
                <p key={index} className="py-4 text-gray-700 leading-relaxed">
                  {item.text}
                </p>
              );

            case "heading":
              return (
                <h2 key={index} className="text-lg font-semibold mt-6">
                  {item.text}
                </h2>
              );

            case "quote":
              return (
                <div
                  key={index}
                  className="flex items-center gap-3 border-l-4 border-blue pl-4 my-6"
                >
                  <p className="text-lg italic font-light">{item.text}</p>
                </div>
              );

            case "media":
              if (item.mediaType === "image") {
                return (
                  <img
                    key={index}
                    src={item.src}
                    alt=""
                    className="w-full h-96 object-cover rounded-3xl my-6"
                  />
                );
              }

              if (item.mediaType === "video") {
                return (
                  <video
                    key={index}
                    controls
                    className="w-full h-96 object-cover rounded-3xl my-6"
                  >
                    <source src={item.src} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                );
              }

              return null;

            default:
              return null;
          }
        })}
      </div> */}
    </div>
  );
};

export default DeatailResourcesPage;
